import { render, staticRenderFns } from "./CreateMerchantUserModal.vue?vue&type=template&id=272e03a3&scoped=true&"
import script from "./CreateMerchantUserModal.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantUserModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMerchantUserModal.vue?vue&type=style&index=0&id=272e03a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272e03a3",
  null
  
)

export default component.exports